import { toast } from "react-toastify"
import axios from "axios"
import moment from "moment"

export const SET_GRN_LOADING = "SET_GRN_LOADING"
export const SET_GRNS = "SET_GRNS"
export const SET_TOTAL_GRNS = "SET_TOTAL_GRNS"
export const SET_TOTAL_GRN_PAGES = "SET_TOTAL_GRN_PAGES"
export const SET_GRN_DATE = "SET_GRN_DATE"
export const SET_GRN_SUPPLIER_CODE = "SET_GRN_SUPPLIER_CODE"
export const SET_GRN_PO_NUMBER = "SET_GRN_PO_NUMBER"
export const SET_GRN_IR_NUMBER = "SET_GRN_IR_NUMBER"
export const SET_GRN_SUPPLIER_INVOICE_NUMBER = "SET_GRN_SUPPLIER_INVOICE_NUMBER"
export const SET_GRN_PRODUCTS = "SET_GRN_PRODUCTS"
export const CLEAR_NEW_GRN = "CLEAR_NEW_GRN"
export const LOAD_GRN_FOR_EDIT = "LOAD_GRN_FOR_EDIT"
export const ADD_GRN_PRODUCT = "ADD_GRN_PRODUCT"
export const DELETE_GRN_PRODUCT = "DELETE_GRN_PRODUCT"

// Get all GRNs from db
export const getGRNs = data => {
  return async (dispatch, getState) => {
    const skip = data?.skip || 1
    const limit = data?.limit || 25
    const search = data?.search || ""

    dispatch({
      type: SET_GRN_LOADING,
      data: true,
    })

    const token = getState().auth.auth.token

    try {
      const res = await axios.get(
        `${process.env.GATSBY_API_CALL}/grns?page=${skip}&limit=${limit}${
          search && "&search=" + encodeURIComponent(search)
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      dispatch({
        type: SET_GRNS,
        data: res.data.grns,
      })

      dispatch({
        type: SET_TOTAL_GRNS,
        data: res.data.totalGRNs,
      })

      dispatch({
        type: SET_TOTAL_GRN_PAGES,
        data: res.data.totalPages,
      })

      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })
    } catch (e) {
      console.log(e)
      toast.error(`Error: ${e.response?.data.error || "Failed to fetch GRNs"}`)
      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })
    }
  }
}

export const loadGRNForEdit = grn => ({
  type: LOAD_GRN_FOR_EDIT,
  data: {
    date: grn.date,
    supplierCode: grn.supplierCode,
    poNumber: grn.poNumber || "",
    irNumber: grn.irNumber || "",
    supplierInvoiceNumber: grn.supplierInvoiceNumber || "",
    products: (grn.products || []).map(p => ({ ...p })),
  },
})

export const fetchGRNById = id => {
  return async (dispatch, getState) => {
    const token = getState().auth.auth.token
    const res = await axios.get(`${process.env.GATSBY_API_CALL}/grns/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return res.data
  }
}

// Save new GRN to db — optional { status: 'pending' | 'incomplete' }
export const saveGRN = (options = {}) => {
  return async (dispatch, getState) => {
    const token = getState().auth.auth.token
    const grnData = getState().grn.newGRN

    if (!grnData.supplierCode) {
      toast.error("Supplier Code is required")
      return
    }

    if (!grnData.products || grnData.products.length === 0) {
      toast.error("At least one product is required")
      return
    }

    // Validate that all products have required fields
    const hasInvalidProducts = grnData.products.some(
      product => !product.itemCode || !product.description || !product.orderQty
    )

    if (hasInvalidProducts) {
      toast.error(
        "All products must have Item Code, Description, and Order Quantity"
      )
      return
    }

    dispatch({
      type: SET_GRN_LOADING,
      data: true,
    })

    try {
      const status = options.status || grnData.status || "pending"

      const res = await axios.post(
        `${process.env.GATSBY_API_CALL}/grns`,
        {
          ...grnData,
          status,
          date: grnData.date || moment().toISOString(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      toast.success(
        `GRN created successfully! GRN Number: ${res.data.grnNumber}`
      )

      dispatch({
        type: CLEAR_NEW_GRN,
      })

      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })

      dispatch(getGRNs())

      return res.data
    } catch (e) {
      console.log(e)
      toast.error(`Error: ${e.response?.data.error || "Failed to create GRN"}`)
      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })
    }
  }
}

// Update GRN
export const updateGRN = (grnId, updateData) => {
  return async (dispatch, getState) => {
    const token = getState().auth.auth.token

    dispatch({
      type: SET_GRN_LOADING,
      data: true,
    })

    try {
      const res = await axios.patch(
        `${process.env.GATSBY_API_CALL}/grns/${grnId}`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      toast.success("GRN updated successfully!")

      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })

      dispatch(getGRNs())

      return res.data
    } catch (e) {
      console.log(e)
      toast.error(`Error: ${e.response?.data.error || "Failed to update GRN"}`)
      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })
    }
  }
}

// Approve GRN
export const approveGRN = grnId => {
  return async (dispatch, getState) => {
    const token = getState().auth.auth.token

    dispatch({
      type: SET_GRN_LOADING,
      data: true,
    })

    try {
      const res = await axios.patch(
        `${process.env.GATSBY_API_CALL}/grns/${grnId}/approve`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      toast.success("GRN approved successfully!")

      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })

      dispatch(getGRNs())

      return res.data
    } catch (e) {
      console.log(e)
      toast.error(`Error: ${e.response?.data.error || "Failed to approve GRN"}`)
      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })
    }
  }
}

// Add GRN delivered quantities to stock
export const addGRNToStock = (grnId, productSerials = {}) => {
  return async (dispatch, getState) => {
    const token = getState().auth.auth.token

    dispatch({
      type: SET_GRN_LOADING,
      data: true,
    })

    try {
      const res = await axios.patch(
        `${process.env.GATSBY_API_CALL}/grns/${grnId}/add-to-stock`,
        { productSerials },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      toast.success("GRN quantities added to stock successfully!")
      dispatch(getGRNs())
      return res.data
    } catch (e) {
      console.log(e)
      toast.error(
        `Error: ${e.response?.data?.error || "Failed to add GRN to stock"}`
      )
      throw e
    } finally {
      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })
    }
  }
}

// Add GRN delivered quantities to replacement stock
export const addGRNToReplacementStock = (grnId, productSerials = {}) => {
  return async (dispatch, getState) => {
    const token = getState().auth.auth.token

    dispatch({
      type: SET_GRN_LOADING,
      data: true,
    })

    try {
      const res = await axios.patch(
        `${process.env.GATSBY_API_CALL}/grns/${grnId}/add-to-replacement-stock`,
        { productSerials },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )

      toast.success("GRN Quantities Added to Replacement Stock Successfully!")
      dispatch(getGRNs())
      return res.data
    } catch (e) {
      console.log(e)
      toast.error(
        `Error: ${
          e.response?.data?.error || "Failed to Add GRN to Replacement Stock"
        }`
      )
      throw e
    } finally {
      dispatch({
        type: SET_GRN_LOADING,
        data: false,
      })
    }
  }
}

// Load GRN data from Purchase Order for creation
export const loadGRNFromPO = poData => {
  return dispatch => {
    dispatch({
      type: SET_GRN_SUPPLIER_CODE,
      data: poData.supplierCode,
    })

    dispatch({
      type: SET_GRN_PO_NUMBER,
      data: poData.poNumber,
    })

    dispatch({
      type: SET_GRN_IR_NUMBER,
      data: poData.irNumber,
    })

    const grnProducts = (poData.poProducts || []).map(product => ({
      itemCode: product.itemCode,
      description: product.description,
      orderQty: product.quantity,
      deliveredQty: 0,
      remarks: "",
    }))

    dispatch({
      type: SET_GRN_PRODUCTS,
      data: grnProducts,
    })

    dispatch({
      type: SET_GRN_DATE,
      data: moment().toISOString(),
    })
  }
}

// Load GRN data from Purchase Order for creation
export const loadGRNFromIR = irData => {
  return dispatch => {
    dispatch({
      type: SET_GRN_SUPPLIER_CODE,
      data: irData.supplierCode,
    })

    dispatch({
      type: SET_GRN_IR_NUMBER,
      data: irData.irNumber,
    })

    const grnProducts = (irData.products || []).map(product => ({
      itemCode: product.itemCode,
      description: product.description,
      orderQty: product.orderQty,
      deliveredQty: 0,
      remarks: "",
    }))

    dispatch({
      type: SET_GRN_PRODUCTS,
      data: grnProducts,
    })

    dispatch({
      type: SET_GRN_DATE,
      data: moment().toISOString(),
    })
  }
}

// Action creators for form data
export const setGRNDate = date => ({
  type: SET_GRN_DATE,
  data: date,
})

export const setGRNSupplierCode = supplierCode => ({
  type: SET_GRN_SUPPLIER_CODE,
  data: supplierCode,
})

export const setGRNPONumber = poNumber => ({
  type: SET_GRN_PO_NUMBER,
  data: poNumber,
})

export const setGRNIRNumber = irNumber => ({
  type: SET_GRN_IR_NUMBER,
  data: irNumber,
})

export const setGRNSupplierInvoiceNumber = supplierInvoiceNumber => ({
  type: SET_GRN_SUPPLIER_INVOICE_NUMBER,
  data: supplierInvoiceNumber,
})

export const setGRNProducts = products => ({
  type: SET_GRN_PRODUCTS,
  data: products,
})

export const clearNewGRN = () => ({
  type: CLEAR_NEW_GRN,
})

// Add a single product to the new GRN from product catalog
export const addGrnProduct = productId => {
  return (dispatch, getState) => {
    const state = getState()
    const products = state.product.products || []
    const current = state.grn?.newGRN?.products || []

    const productData = products.find(p => p.id === productId)
    if (!productData) {
      toast.error("Product not found")
      return
    }

    const alreadyExists = current.some(
      prod => prod.id === productData.id || prod.itemCode === productData.sku
    )
    if (alreadyExists) {
      toast.error("Product already added")
      return
    }

    const newItem = {
      id: productData.id,
      itemCode: productData.sku,
      description: productData.productName,
      orderQty: 1,
      deliveredQty: 0,
      remarks: "",
    }

    const updated = [...current, newItem]
    dispatch({ type: SET_GRN_PRODUCTS, data: updated })
  }
}

// Remove a product from the new GRN by product id
export const deleteGrnProduct = productId => {
  return (dispatch, getState) => {
    const current = getState().grn?.newGRN?.products || []
    const updated = current.filter(prod => prod.id !== productId)
    dispatch({ type: SET_GRN_PRODUCTS, data: updated })
  }
}
